import * as React from "react";

const TrueFalseTemplate = (value: boolean, header?: string) => {
  return (
    <div>
      {header && (
        <span>
          <span className="ml-2 text-sm font-semibold lg:hidden lg:ml-0">
            {header}
          </span>
          <span className="mx-2 lg:hidden">-</span>
        </span>
      )}
      {value ? (
        <span className="text-gray-700 pi pi-check"></span>
      ) : (
        <span className="text-gray-700 pi pi-times"></span>
      )}
    </div>
  );
};

export default TrueFalseTemplate;
